import { render, staticRenderFns } from "./RelatedDevices.vue?vue&type=template&id=ae7c1a54&scoped=true"
import script from "./RelatedDevices.vue?vue&type=script&lang=js"
export * from "./RelatedDevices.vue?vue&type=script&lang=js"
import style0 from "./RelatedDevices.vue?vue&type=style&index=0&id=ae7c1a54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7c1a54",
  null
  
)

export default component.exports